/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export class Button extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    type: PropTypes.oneOf(["reset", "brand", "destructive", "inverse", "default"]),
    disabled: PropTypes.bool,
    children: PropTypes.any.isRequired,
    onClick: PropTypes.func,  // is optional, but without onClick prop event won't trigger any action
    className: PropTypes.string,
    title: PropTypes.string,
    minWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    style: PropTypes.object
  }

  static defaultProps = {
    type: 'default',
    className: ''
  }

  renderButton = ({ id, type, disabled, children, onClick, className, title, minWidth=0, maxHeight='none', marginLeft, style }) => {
    const buttonStyle = style
      ? { ...style, maxHeight, minWidth, marginLeft }
      : { maxHeight, minWidth, marginLeft }

    switch (type) {
      case "reset":
        return (
          <button
            id={id}
            className={`slds-button ${className}`}
            disabled={disabled}
            onClick={onClick}
            title={title}
            style={{ ...buttonStyle, boxShadow: 'none' }}>
            {children}
          </button>
        )

      case "brand":
        return (
          <button
            id={id}
            className={`slds-button slds-button_brand ${className}`}
            onClick={onClick}
            disabled={disabled}
            title={title}
            style={buttonStyle}>
            {children}
          </button>
        )

      case "destructive":
        return (
          <button
            id={id}
            className={`slds-button slds-button_destructive ${className}`}
            onClick={onClick}
            disabled={disabled}
            title={title}
            style={buttonStyle}>
            {children}
          </button>
        )

      case "inverse":
        return (
          <button
            id={id}
            className={`slds-button slds-button_inverse ${className}`}
            onClick={onClick}
            disabled={disabled}
            title={title}
            style={buttonStyle}>
            {children}
          </button>
        )

      default:
        return (
          <button
            id={id}
            className={`slds-button slds-button_neutral ${className}`}
            onClick={onClick}
            disabled={disabled}
            title={title}
            style={buttonStyle}>
            {children}
          </button>
        )
    }
  }

  render() {
    return this.renderButton(this.props)
  }
}



// WEBPACK FOOTER //
// ./src/components/button/index.js